import script from "./InningGames.vue?vue&type=script&setup=true&lang=js"
export * from "./InningGames.vue?vue&type=script&setup=true&lang=js"

import "./InningGames.vue?vue&type=style&index=0&id=5062e22a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5062e22a"]])

export default __exports__